<template>
  <transition name="message-fade">
    <div class="message-container" v-if="visible">
      <div class="message-content" :class="type">
        <div class="message-icon">
          <span v-if="type === 'success'" class="icon-success">✓</span>
          <span v-else-if="type === 'error'" class="icon-error">ⓧ</span>
          <span v-else-if="type === 'warning'" class="icon-warning">⚠</span>
          <span v-else class="icon-info">ℹ</span>
        </div>
        <div class="message-text">{{ message }}</div>
        <div class="message-close" @click="close">×</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      visible: false,
      message: "",
      type: "info",
      timer: null,
    };
  },
  methods: {
    open(message, type = "info", duration = 3000) {
      this.message = message;
      this.type = type;
      this.visible = true;

      if (duration > 0) {
        this.timer = setTimeout(() => {
          this.close();
        }, duration);
      }
    },
    close() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.message-container {
  position: fixed;
  top: 8%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999999;
  display: flex;
  justify-content: center;
  align-items: center;

  .message-content {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background: #fff;
    min-width: 240px;
    max-width: 400px;

    &.success {
      border-left: 4px solid #52c41a;

      .message-icon {
        color: #52c41a;
      }
    }

    &.error {
      border-left: 4px solid #ff4d4f;

      .message-icon {
        color: #ff4d4f;
      }
    }

    &.warning {
      border-left: 4px solid #faad14;

      .message-icon {
        color: #faad14;
      }
    }

    &.info {
      border-left: 4px solid #1890ff;

      .message-icon {
        color: #1890ff;
      }
    }

    .message-icon {
      font-size: 20px;
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;

      span {
        display: block;
      }
    }

    .message-text {
      flex: 1;
      font-size: 14px;
      color: #333;
      line-height: 20px;
    }

    .message-close {
      font-size: 18px;
      color: #999;
      cursor: pointer;
      margin-left: 12px;
      transition: color 0.3s;

      &:hover {
        color: #333;
      }
    }
  }
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.3s;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
}
</style>
